export default __webpack_public_path__ + "c6512078df8614c35539e4867dbe096c.png";